import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const offerSection = document.getElementById('oferta');
      if (offerSection) {
        offerSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-lg md:text-xl font-heading font-bold text-dark bg-accent-yellow rounded-full overflow-hidden shadow-[0_0_15px_rgba(255,215,0,0.4)] hover:shadow-[0_0_25px_rgba(255,215,0,0.6)] transition-all duration-300 ${className}`} data-id="element-60">
      <span className="relative z-10 flex items-center gap-2" data-id="element-61">
        {text}
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-62" />
      </span>
      <div className="absolute inset-0 bg-gradient-to-r from-accent-yellow via-white to-accent-yellow opacity-0 group-hover:opacity-20 transition-opacity duration-300" data-id="element-63" />
    </motion.button>;
}